
<template>
  <b-card no-body  v-if="mainContact != null">
    <b-card-header :class="{'bg-danger text-white': company && company.companyStatus.id == 900}">
      <h4>Main Contact</h4>
    </b-card-header>

    <b-card-body>
      <b-alert v-if="callInProgress && callLocation === 'main'" show variant="info">
        <b-spinner small label="Starting call"></b-spinner> Starting call...
      </b-alert>
      <b-card-text>
        <div class="label">Main Contact Name</div>
        <div class="text">
          {{ mainContact.fullname || `${mainContact.title} ${mainContact.firstName} ${mainContact.lastName}`}}
          <span v-if="mainContact.knownAs">({{ mainContact.knownAs }})</span>
        </div>
        <div class="label">Preferred Contact Number</div>
        <div class="text"
             v-bind:class="{ red: mainContact.preferredContactNumberCtps }"
             v-if="!mainContact.doNotUsePreferredContactNumber">

          <b-button v-if="enableCallButtons && mainContact.preferredContactNumber != null && mainContact.preferredContactNumber != '' && !mainContact.doNotUsePreferredContactNumber && !mainContact.preferredContactNumberCtps"
                    variant="info"
                     type="button"
                     size="sm"
                     :disabled="callInProgress"
                     @click="makeCall(mainContact.preferredContactNumber, mainContact.id)">Call</b-button>
          {{ mainContact.preferredContactNumber }}
        </div>
        <div class="label">Other Contact Number</div>
        <div class="text"
             v-bind:class="{ red: mainContact.otherContactNumberCtps }">
          <b-button v-if="enableCallButtons && mainContact.otherContactNumber != null && mainContact.otherContactNumber != '' && !mainContact.otherContactNumbberCtps"
                    variant="info"
                     type="button"
                     size="sm"
                     :disabled="callInProgress"
                     @click="makeCall(mainContact.otherContactNumber, mainContact.id)">Call</b-button>
          {{ mainContact.otherContactNumber }}
        </div>
        <div class="label">General Business Tel. Numbers</div>
        <div class="text"
             v-bind:class="{
            red:
              mainContact.telephoneBusinessCtps ||
              mainContact.doNotUseTelephoneBusiness,
          }">
          <b-button v-if="enableCallButtons && mainContact.telephoneBusiness != null && mainContact.telephoneBusiness != '' && !mainContact.telephoneBusinessCtps && !mainContact.doNotUseTelephoneBusiness"
                    variant="info"
                     type="button"
                     size="sm"
                     :disabled="callInProgress"
                     @click="makeCall(mainContact.telephoneBusiness, mainContact.id)">Call</b-button>
          {{ mainContact.telephoneBusiness }}
        </div>
        <div class="label">Main Contact Email Address</div>
        <div
          class="text"
          v-bind:class="{ red: mainContact.doNotUseEmailAddress }"
        ><a :href="`mailto:${mainContact.emailAddress}`">
          {{ mainContact.emailAddress }}</a>
        </div>
      </b-card-text>
    </b-card-body>
    <b-card-body v-if="mainContactGroup">
      <b-card-text>
        <div class="label">Group Tel. Number</div>
        <div class="text" v-bind:class="{ red: mainContactGroup.groupCompanyTelephoneNoCtps }">
              <b-button v-if="enableCallButtons && mainContactGroup.groupCompanyTelephoneNo != null && mainContactGroup.groupCompanyTelephoneNo != ''"
           variant="info"
           type="button"
           size="sm"
           :disabled="callInProgress"
           @click="makeCall(mainContactGroup.groupCompanyTelephoneNo)">Call</b-button>
             {{mainContactGroup.groupCompanyTelephoneNo}}
        </div>
        <div class="label">Group Email Address</div>
        <div class="text"><a :href="`mailto:${mainContactGroup.groupEmailAddress}`">{{mainContactGroup.groupEmailAddress}}</a></div>
        <div class="label">Group Tel. Company</div>
        <div class="text"><router-link :to="`/company/${mainContactGroup.groupTelephoneCompanyId}`">{{mainContactGroup.groupTelephoneCompanyName}}</router-link></div>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>

export default {
  name: "MainContact",
  props: {
    companyId: String,
    mainContact: Object,
    mainContactGroup: Object,
    company: Object,
    enableCallButtons: Boolean,
    callInProgress: Boolean,
    callLocation: String,
  },
  data() {
    return {
      otherNumberDoNotCall: false,
    };
  },
  methods: {
    makeCall(number, vendorId) {
      this.$emit('makeCall', number, vendorId, 'main');
    }
  },
};
</script>

<style scoped>
h4 {
  margin-bottom: 0;
}

.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
</style>
